module.exports = "pegasus_template/assets/hexline-facebook.png";